import styled from '@emotion/styled'

import { colors, palette, spacing, Text } from 'main/ui'
import { dateCardContainerMaxWidth } from './styles'

export const chevronIconSize = 35
export const chevronIconColor = palette.chrome
export const chevronIconColorDisabled = palette.lightGray

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`

export const DayCarouselContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(3)}px;
  }
`

export const DaysContainer = styled.div`
  display: flex;
  flex-direction: row;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`

export const ChevronContainer = styled.div<{ active: boolean }>`
  cursor: ${({ active }) => (active ? 'pointer' : 'inherit')};
`

export const SelectBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const SelectContainer = styled.div`
  flex-grow: 1;
  max-width: ${dateCardContainerMaxWidth}px;
`

export const ValidationHint = styled(Text)`
  color: ${colors.text.error};
`
